import { ButtonColor } from "@/common/enum/button-color";
import { GrayMinusButton } from "@/components/button/GrayMinusButton";
import { GrayPlusButton } from "@/components/button/GrayPlusButton";
import { CloseOutlineIcon } from "@/components/icon/CloseOutlineIcon";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Table } from "flowbite-react";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { ItemDetailLineDto } from "../../../types/dto/item-detail-line-dto";
import { StatusButton } from "../../button/StatusButton";
import { CustomCell } from "../CustomCell";

interface Props {
  data: ItemDetailLineDto;
  addQuantity: (id: number) => void;
  subtractQuantity: (id: number) => void;
  removeItem: (id: number) => void;
  // handleItemNameClick: (id: number) => void;
}

export const PackageItemChildTableRow: React.FC<Props> = ({
  data,
  // handleItemNameClick,
  addQuantity,
  subtractQuantity,
  removeItem,
}) => {
  const item = data;

  return (
    <Table.Row
      key={item.childItem.id}
      className="bg-white text-semantic-text-body"
    >
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{item.childItem.category.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{item.childItem.erpCode}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{item.childItem.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="flex items-center">
        <CustomCell>
          <GrayMinusButton
            handleClick={() => {
              subtractQuantity(item.childItem.id);
            }}
          />
          <Body14Regular className="mx-[10px]">{item.quantity}</Body14Regular>
          <GrayPlusButton
            handleClick={() => {
              addQuantity(item.childItem.id);
            }}
          />
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>
            {formatCommasNumber(item.childItem.price)}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <StatusButton color={ButtonColor.CUSTOM_GRAY}>
            {item.childItem.isForSale ? "판매중" : "판매 안함"}
          </StatusButton>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <StatusButton color={ButtonColor.CUSTOM_GRAY}>
            {item.childItem.isDisplayed ? "진열중" : "진열 안함"}
          </StatusButton>
        </CustomCell>
      </Table.Cell>
      <Table.Cell
      // onClick={handleIsCatalogedClick}
      >
        <div className="flex items-center justify-center">
          <CloseOutlineIcon
            className="cursor-pointer"
            onClick={() => removeItem(item.childItem.id)}
          />
          {/* <RefreshButton
            color={item.isCataloged ? ButtonColor.GREEN : ButtonColor.RED}
            handleClick={handleIsCatalogedClick}
          >
            {item.isCataloged
              ? CatalogStatus.CATALOGED
              : CatalogStatus.NOT_CATALOGED}
          </RefreshButton> */}
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
